(() => {
  'use strict';
  if (window.BosscoAccessoryGallery) return;
  window.BosscoAccessoryGallery = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const origin = event.target.closest('[data-bc-accessory-landing] [data-bc-gallery-index], [data-bc-accessory-details] [data-bc-gallery-index]');
    if (!origin || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const gallery = origin.closest('[data-bc-hero-gallery]');
    if (!gallery || !window.theme?.buildGalleryViewer || !window.jQuery) return;
    let photos;
    try { photos = JSON.parse(gallery.querySelector('[data-bc-gallery-images]').textContent); } catch { return; }
    const index = Number(origin.dataset.bcGalleryIndex);
    if (!photos[index]) return;
    const images = photos.map(photo => {
      const thumb = document.createElement('img');
      thumb.src = photo.thumbUrl; thumb.alt = photo.alt || ''; thumb.loading = 'lazy';
      return {zoomUrl:photo.zoomUrl,thumbTag:window.jQuery(thumb)};
    });
    event.preventDefault();
    window.theme.buildGalleryViewer({images,currentImage:photos[index].zoomUrl,prev:window.theme.icons.chevronLeft,next:window.theme.icons.chevronRight,close:window.theme.icons.close});
    const viewer = document.querySelector('.gallery-viewer');
    if (!viewer) return;
    viewer.classList.add('bc-accessory-gallery-viewer');
    document.documentElement.classList.add('bc-accessory-gallery-open');
    viewer.setAttribute('role','dialog'); viewer.setAttribute('aria-modal','true');
    viewer.setAttribute('aria-label','Product photos');
    viewer.querySelector('.gallery-viewer__close')?.setAttribute('aria-label','Close product photos');
    viewer.querySelector('.gallery-viewer__prev')?.setAttribute('aria-label','Previous photo');
    viewer.querySelector('.gallery-viewer__next')?.setAttribute('aria-label','Next photo');
    const thumbs = Array.from(viewer.querySelectorAll('.gallery-viewer__thumb'));
    thumbs.forEach((thumb,i) => thumb.setAttribute('aria-label',`View photo ${i+1} of ${photos.length}`));
    const counter = document.createElement('p');
    counter.className = 'bc-accessory-gallery-viewer__counter'; counter.setAttribute('role','status'); counter.setAttribute('aria-live','polite');
    viewer.appendChild(counter);
    const update = () => {
      const current = Math.max(0,thumbs.findIndex(thumb => thumb.classList.contains('gallery-viewer__thumb--active')));
      const label = `${current+1} / ${photos.length}`;
      if (counter.textContent !== label) counter.textContent = label;
      thumbs.forEach((thumb,i) => { if (i===current) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current'); });
      const zoom = viewer.querySelector('.gallery-viewer__zoom-image');
      if (zoom && zoom.alt !== photos[current].alt) zoom.alt = photos[current].alt || '';
    };
    const changes = new MutationObserver(update);
    changes.observe(viewer,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
    update();
    viewer.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const controls = Array.from(viewer.querySelectorAll('a[href],button,[tabindex="0"]')).filter(node => node.getClientRects().length);
      const first = controls[0], last = controls.at(-1);
      if (e.shiftKey && document.activeElement===first) { e.preventDefault(); last?.focus(); }
      else if (!e.shiftKey && document.activeElement===last) { e.preventDefault(); first?.focus(); }
    });
    const removal = new MutationObserver(() => {
      if (viewer.isConnected) return;
      changes.disconnect(); removal.disconnect();
      if (!document.querySelector('.bc-accessory-gallery-viewer')) document.documentElement.classList.remove('bc-accessory-gallery-open');
      if (origin.isConnected && !document.querySelector('.gallery-viewer')) origin.focus({preventScroll:true});
    });
    removal.observe(document.body,{childList:true});
  });
})();
